import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpParams, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, Subject, timer} from 'rxjs';
import {AppConfig} from '../services/AppConfig';
import {GfxStoreService} from './gfx.store.service';
import {GfxMiscSrv} from './gfx.misc.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../environments/environment';
import {SharingDataService} from './sharing-data.service';
import {AuthService} from './auth.service';

@Injectable()
export class GfxUpDownHelper {
    gauth: string;

    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(AppConfig) private appConfig: AppConfig,
        private store: GfxStoreService,
        private miscSrv: GfxMiscSrv,
        private spinner: NgxSpinnerService,
        private cookieService: CookieService,
        private sharing: SharingDataService,
        private authService: AuthService,
    ) {
        //this.gauth = this.store.getCurrUser().token;
    }

    public upload(file: File, url: string, arrayParams?): Observable<number> {
        const tokenXSRF = this.cookieService.get('XSRF-TOKEN');
        const headerSettingsLogin: { [name: string]: string | string[] } = {};
        headerSettingsLogin['X-XSRF-TOKEN'] = tokenXSRF;
        headerSettingsLogin['AUTHORIZATION'] = this.store.curUser.access_token;
        const newHeader = new HttpHeaders(headerSettingsLogin);


        const formData: FormData = new FormData();
        formData.append('file', file, file.name);

        const parmMeta = {};
        arrayParams.forEach((element) => {
            if (element) {
                parmMeta[element.Name] = element.Value;
            }
        });

        formData.append(
            'metadata',
            new Blob([JSON.stringify(parmMeta)], { type: 'application/json' })
        );

        const req = new HttpRequest(
            'POST',
            url,
            formData,
            {
                reportProgress: true,
                // params,
                headers: newHeader,
                withCredentials: true
            }
        );

        const progress = new Subject<number>();

        this.http
            .request(req)
            .toPromise()
            .then((event) => {
                if (event.type === HttpEventType.UploadProgress) {
                    let perc = Math.round((100 * event.loaded) / event.total);
                    progress.next(perc);
                } else if (event instanceof HttpResponse) {
                    progress.complete();
                    this.spinner.hide();
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.spinner.hide();
                this.miscSrv.openDialogView({data: error});
                //    this.miscSrv.openSnackBarBeMsg({ data: error, duration: 3000 });
            });

        return progress.asObservable();
    }

    public download(url: string, data?): Observable<Blob> {
        const headerSettings: { [name: string]: string | string[] } = {};
        const backendUrl = environment.BackendUrl;
        url = backendUrl + '/' + url;
        let params = new HttpParams();
        if (data) {
            Object.keys(data).forEach(function (item) {
                params = params.set(item, data[item]);
            });
        }
        const tokenXSRF = this.cookieService.get('XSRF-TOKEN');
        const currentUser = this.store.curUser;
        if (currentUser) {
            headerSettings['Authorization'] = currentUser.access_token;
        }


        headerSettings['X-XSRF-TOKEN'] = tokenXSRF;
        const newHeader = new HttpHeaders(headerSettings);
        return this.http.get(url, {headers: newHeader, responseType: 'blob', params: params, withCredentials: true});
    }

    public downloadDoc(url: string, data?) {
        const headerSettings: { [name: string]: string | string[] } = {};

        let params = new HttpParams();
        if (data) {
            Object.keys(data).forEach(function (item) {
                params = params.set(item, data[item]);
            });
        }
        const backendUrl = environment.BackendUrl;

        headerSettings['GAuth'] = this.gauth;
        this.spinner.show();
        const newHeader = new HttpHeaders(headerSettings);
        url = backendUrl + '/' + url;
        let t = setTimeout(() => {
            this.spinner.hide();
        }, 12000000);
        this.http.get(url, {headers: newHeader, responseType: 'blob', params: params, withCredentials: true})
            .subscribe((data) => {
                var file = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.spinner.hide();
            });
    }

    public downloadDocFormat(format, url, params) {
        if (format == 'doc') {
            this.downloadDoc(url, params);

        } else if (format == 'pdf') {
            this.downPdfOpenWindow(url, params);
        }
    }

    public downPdfOpenWindow(url: string, data?) {


        let params = new HttpParams();
        if (data) {
            Object.keys(data).forEach(function (item) {
                params = params.set(item, data[item]);
            });
        }


        const headerSettings: { [name: string]: string | string[] } = {};
        const backendUrl = environment.BackendUrl;
        headerSettings['GAuth'] = this.gauth;
        this.spinner.show();
        const newHeader = new HttpHeaders(headerSettings);
        url = backendUrl + '/' + url;
        let t = setTimeout(() => {
            this.spinner.hide();
        }, 1200000);
        this.http
            .get(url, {headers: newHeader, responseType: 'blob', params: params})
            .subscribe((data) => {
                var file = new Blob([data], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                this.spinner.hide();
            });
    }

    public openReportPdf(frontaction: any) {
        const headerSettings: string | { [name: string]: string | string[] } = {};
        const reportUrl = environment.BackendUrl;
        const tokenXSRF = this.cookieService.get('XSRF-TOKEN');
        const currentUser = this.store.curUser;
        if (currentUser) {
            headerSettings['Authorization'] = currentUser.access_token;
        }

        headerSettings['X-XSRF-TOKEN'] = tokenXSRF;
        const newHeader = new HttpHeaders(headerSettings);
        this.http.post(`${reportUrl}/report${frontaction.url}`,
            frontaction.params,
            {headers: newHeader, responseType: 'blob', withCredentials: true}
        ).subscribe((fileData) => {
            const file = new Blob([fileData], {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        });

    }

    convertToBase64(url: any) {
        this.http.get(url, {responseType: 'blob', withCredentials: true}).subscribe(blob => {
            const reader = new FileReader();
            const binaryString = reader.readAsDataURL(blob);
            reader.onload = (event: any) => {
            };

            reader.onerror = (event: any) => {
            };
        });

    }


    public openReportFromBE(url, frontaction: any) {
        const headerSettings: string | { [name: string]: string | string[] } = {};
        const backendUrl = environment.BackendUrl;
        headerSettings['GAuth'] = ' ';
        const newHeader = new HttpHeaders(headerSettings);
        this.http.post(
            backendUrl + '/' + url,
            frontaction.params,
            {headers: newHeader, responseType: 'blob', withCredentials: true}
        ).subscribe((fileData) => {
            const file = new Blob([fileData], {type: 'application/pdf'});
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);

        });

    }

    public getPdfFileHttp(url, data?) {
        const headerSettings: string | { [name: string]: string | string[] } = {};
        const tokenXSRF = this.cookieService.get('XSRF-TOKEN');
        const currentUser = this.store.curUser;
        if (currentUser) {
            headerSettings['Authorization'] = currentUser.access_token;
        }

        headerSettings['X-XSRF-TOKEN'] = tokenXSRF;
        const newHeader = new HttpHeaders(headerSettings);
        let params = new HttpParams();
        if (data) {
            Object.keys(data).forEach(function (item) {
                params = params.set(item, data[item]);
            });
        }

        const backendUrl = environment.BackendUrl;
        url = backendUrl + '/' + url;
        return this.http
            .get(url, {
                headers: newHeader,
                responseType: 'blob',
                params: params,
                withCredentials: true
            });
    }
}
